<template>
  <div>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.title"
            label-for="title"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.title"
              :rules="$v.title.$params"
            />
            <b-form-input
              type="text"
              autocomplete="off"
              v-model="$v.title.$model"
              :state="$v.title.$dirty ? !$v.title.$error : null"
            >
            </b-form-input>

            <b-form-invalid-feedback id="title-feedback">
              {{ $lang.error_required | replace($lang.title) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.teachingGrade"
            label-for="teachingGrade"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.teachingGrade"
              :rules="$v.teachingGrade.$params"
            />
            <b-form-input
              type="text"
              autocomplete="off"
              v-model="$v.teachingGrade.$model"
              :state="$v.teachingGrade.$dirty ? !$v.teachingGrade.$error : null"
            >
            </b-form-input>

            <b-form-invalid-feedback id="teachingGrade-feedback">
              {{ $lang.error_required | replace($lang.teachingGrade) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.teachingLocation"
            label-for="teachingLocation"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.teachingLocation"
              :rules="$v.teachingLocation.$params"
            />
            <b-form-input
              type="text"
              autocomplete="off"
              v-model="$v.teachingLocation.$model"
              :state="
                $v.teachingLocation.$dirty ? !$v.teachingLocation.$error : null
              "
            >
            </b-form-input>

            <b-form-invalid-feedback id="teachingLocation-feedback">
              {{ $lang.error_required | replace($lang.teachingLocation) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.start_date"
            label-for="fromDate"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.start_date"
              :rules="$v.fromDate.$params"
            />
            <date-picker
              type="date"
              v-model="$v.fromDate.$model"
              :state="$v.fromDate.$dirty ? !$v.fromDate.$error : null"
              inputReq="true"
              auto-submit
              clearable
              simple
              format="YYYY-MM-DD"
              display-format="jYYYY/jMM/jDD"
              :class="
                $v.fromDate.$dirty
                  ? $v.fromDate.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback
              :style="{ display: $v.fromDate.$error ? 'block' : 'none' }"
              id="fromDate-feedback"
            >
              {{ $lang.error_required | replace($lang.start_date) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.end_date"
            label-for="toDate"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.end_date"
              :rules="$v.toDate.$params"
            />
            <date-picker
              type="date"
              v-model="$v.toDate.$model"
              :state="$v.toDate.$dirty ? !$v.toDate.$error : null"
              inputReq="true"
              auto-submit
              clearable
              simple
              format="YYYY-MM-DD"
              display-format="jYYYY/jMM/jDD"
              :class="
                $v.toDate.$dirty
                  ? $v.toDate.$error
                    ? 'invalid-date'
                    : 'valid-date'
                  : null
              "
            >
            </date-picker>
            <b-form-invalid-feedback
              :style="{ display: $v.toDate.$error ? 'block' : 'none' }"
              id="toDate-feedback"
            >
              {{ $lang.error_required | replace($lang.end_date) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.teachingHour"
            label-for="teachingHour"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.teachingHour"
              :rules="$v.teachingHour.$params"
            />
            <b-form-input
              type="text"
              autocomplete="off"
              v-model="$v.teachingHour.$model"
              :state="$v.teachingHour.$dirty ? !$v.teachingHour.$error : null"
            >
            </b-form-input>

            <b-form-invalid-feedback id="teachingHour-feedback">
              {{ $lang.error_numeric | replace($lang.teachingHour) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$lang.studentCount"
            label-for="studentCount"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.studentCount"
              :rules="$v.studentCount.$params"
            />
            <b-form-input
              type="text"
              autocomplete="off"
              v-model="$v.studentCount.$model"
              :state="$v.studentCount.$dirty ? !$v.studentCount.$error : null"
            >
            </b-form-input>

            <b-form-invalid-feedback id="studentCount-feedback">
              {{ $lang.error_numeric | replace($lang.studentCount) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.description"
            label-for="address"
            :label-cols="$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.description"
              :rules="$v.description.$params"
            />
            <b-form-textarea
              id="description"
              type="text"
              v-model="$v.description.$model"
              :autocomplete="$lang.description"
              :rows="this.$config.form.textareaRows"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <div slot="footer" class="form-group form-btn">
            <b-button class="mr-2" variant="outline-danger" @click="cancel">
              <mdicon name="close" size="24" />
              {{ $lang.close }}
            </b-button>
            <b-button
              v-if="isAdmin(parentPermissions)"
              type="submit"
              variant="success"
            >
              <mdicon name="check" size="24" />
              {{ $lang.submitButton }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>
<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { isAdmin, checkCustomKey } from "@/shared/utils";
import { pathOr } from "ramda";
import { required, numeric } from "vuelidate/lib/validators";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  validations: {
    title: { required },
    teachingGrade: {},
    teachingLocation: {},
    fromDate: { required },
    toDate: { required },
    teachingHour: {numeric},
    studentCount: { numeric },
    description: {},
  },
  data() {
    return {
      title: null,
      teachingGrade: null,
      fromDate: null,
      toDate: null,
      teachingLocation: null,
      teachingHour: null,
      studentCount: null,
      description: null,
    };
  },
  watch: {
    item: {
      immediate: true,
      handler(value) {
        if (value) {
          this.fetchData(value);
        }
      },
    },
  },
  methods: {
    pathOr,
    isAdmin,
    checkCustomKey,
    cancel() {
      this.$emit("cancel");
    },
    save() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      const payload = {
        name: this.title,
        from_date: this.fromDate,
        to_date: this.toDate,
        teaching_grade: this.teachingGrade,
        teaching_location: this.teachingLocation,
        teaching_hour: this.teachingHour,
        student_count: this.studentCount,
        description: this.description,
      };
      this.$emit("submit", payload);
    },
    async fetchData() {
      this.title = pathOr(null, ["name"], this.item);
      this.teachingGrade = pathOr(null, ["teaching_grade"], this.item);
      this.fromDate = pathOr(null, ["from_date", "gregorian"], this.item);
      this.toDate = pathOr(null, ["to_date", "gregorian"], this.item);
      this.teachingLocation = pathOr(null, ["teaching_location"], this.item);
      this.teachingHour = pathOr(null, ["teaching_hour"], this.item);
      this.studentCount = pathOr(null, ["student_count"], this.item);
      this.description = pathOr(null, ["description"], this.item);
    },
  },
};
</script>
